document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/g, "") + "js";

if (window.location.hash) { setTimeout(function () { window.scrollTo(0, 0); }, 2); }

jQuery(document).ready(function ($) {
    AOS.init({ once: true });

    /*-----------------------------------------------------------------------------GLOBAL ON LOAD----*/

    var Cookie = (function () {
        /**
         * get cookie value
         * @param   {String} strName - cookie name
         * @returns {String}         - cookie value
         */
        var get = function (strName) {
            // seperate cookies into array
            var arrCookies = decodeURIComponent(document.cookie).split("; ");
            // initiate cookie value return
            var strCookieValue;
            // remove whitespace
            strName = strName;

            // cycle through cookies
            arrCookies.forEach(function (strCookie) {
                // find cookie and return value
                if (strCookie.indexOf(strName + "=") === 0) {
                    strCookieValue = strCookie.split('=')[1];
                }
            });

            // if cookie value is undefined
            // if (!strCookieValue) console.warn("Cookie '" + strName + "' does not exist");
            // return cookie value
            return strCookieValue;

        };
        /**
         * Set cookies
         * @param {String} strName        - cookie name
         * @param {String} strValue       - cookie value
         * @param {Number} [intExpInDays] - days until cookie expires
         * @param {String} [strPath]      - path where cookie is accessible
         */
        var set = function (strName, strValue, intExpInDays, strPath) {
            var strExpires = "";
            /* if strPath is undefined
             * default to domain root */
            strPath = strPath || "/";

            // if intExpInDays is defined
            if (intExpInDays) {
                var objExpireDate = new Date();
                // set time to expiration date
                objExpireDate.setTime(objExpireDate.getTime() + (intExpInDays * 24 * 60 * 60 * 1000));
                // format to cookie param
                strExpires = "expires=" + objExpireDate.toUTCString() + ";";
            }
            // set cookie
            document.cookie = strName + "=" + strValue + ";" + strExpires + "path=" + strPath;
        };

        /**
         * remove cookie
         * @param {String} strName - cookie name
         */
        var remove = function (strName) {
            // if cookie exists - set expiration to day before
            if (get(strName) !== undefined) set(strName, '_', -1);
        };

        return {
            get: get,
            set: set,
            delete: remove,
        };
    })();

    var LazyLoading = (function () {
        var instance = new LazyLoad();

        function lazyBGImages() {
            var $bgImages = $('[data-bg]:not(.lazy)');
            if ($bgImages.length) {
                $bgImages.each(function () {
                    $(this).addClass('lazy');
                });
            }

            instance.update();
        }

        function update() {
            lazyBGImages();
        }

        lazyBGImages();

        return {
            update: update
        }
    }());

    var SmoothScroll = (function () {
        var $anchorLinks = $('a[href^="#"]').not('a[href="#"]');

        $('a[href="#"]').click(
            function (e) { e.preventDefault(); return; }
        );

        function goTo(target) {
            if (target === "" || !$(target).length) { return; }
            var scrollPos = typeof target === 'number' ? target : $(target).offset().top;

            if (window.innerWidth >= 720) {
                scrollPos -= $('header').outerHeight();
            } else {
                scrollPos -= $('header').outerHeight() * 2;
            }

            $('html, body').stop().animate({
                'scrollTop': scrollPos - 32
            }, 1200, 'swing', function () {
                if (typeof target === 'string') {

                    if (window.location.hash) {
                        // window.location.hash = target;
                    }
                }
            });
        }

        if (window.location.hash) {
            setTimeout(function () {
                goTo(window.location.hash);
            }, 500);
        }

        if ($anchorLinks.length) {
            $anchorLinks.on('click', function (e) {
                if (!$("#" + this.hash.replace('#', '')).length) { return; }
                e.preventDefault();
                goTo(this.hash);
            });
        }

        return { to: goTo }
    }());

    //Global function to toggle simple accordions
    var Accordions = (function () {
        var $accordions = $('.accordion');
        if (!$accordions.length) { return; }

        $accordions.each(function () {
            if ($(this).hasClass('active')) {
                $(this).find('.accordion__content').show();
            }
        });

        $accordions.find('.accordion__trigger').click(function (e) {
            var $this = $(this);
            var $accordion = $this.parent();
            var $content = $accordion.find('.accordion__content');
            var $siblings = $accordion.siblings();

            if ($accordion.hasClass('active')) {
                $accordion.removeClass('active');
                $content.slideUp('fast');
            } else {
                $accordion.addClass('active');
                $siblings.removeClass('active').find('.accordion__content').slideUp('fast');
                $content.slideDown('fast');
            }
        })

    }());

    var Forms = (function () {
        var InputMasks = (function () {
            var $masks = $('[data-mask]');
            if (!$masks.length) { return; }

            /**
             * Key Codes:
             * 8    - backspace
             * 13   - enter
             * 16   - shift
             * 18   - alt
             * 20   - caps
             * 27   - esc
             * 37   - left arrow
             * 38   - up arrow
             * 39   - right arrow
             * 40   - down arrow
             * 46   - delete
             **/
            var exclude_keys = [8, 13, 16, 18, 20, 27, 37, 38, 39, 40, 46];

            $('[data-mask]').keyup(function (e) {
                if (exclude_keys.indexOf(e.keyCode) > -1) { return; }

                switch (this.dataset.mask) {
                    case 'digits':
                        var x = this.value.replace(/\D/g, '');
                        this.value = x;
                        break;
                    case 'phone':
                        var x = this.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                        this.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                        break;
                    case 'ssn': {
                        var x = this.value.replace(/\D/g, '').match(/^(\d{0,3})(\d{0,2})(\d{0,4})/);
                        this.value = !x[2] ? x[1] : x[1] + '-' + x[2] + '-' + x[3];
                    }
                }
            });
        }());

        //Plugin used for form validation
        var parselyOptions = {
            classHandler: function (parsleyField) {
                var $element = parsleyField.$element;
                if ($element.parent().hasClass('select-menu')) {
                    return $element.parent();
                }
                return $element;
            },
            errorsContainer: function (parsleyField) {
                var $element = parsleyField.$element;
                var $fieldContainer = $element.closest('.form-field');
                if ($fieldContainer) {
                    return $fieldContainer;
                }
            }
        };

        //Global function to set form state classes
        var formStates = (function () {
            $formInputs = $('form :input');
            if (!$formInputs.length) { return; }

            $formSelectMenus = $('.select-menu select, .ginput_container_select select');

            function isGFormInput($el) {
                return $el.parent().hasClass('ginput_container') ? $el.parent().parent() : $el;
            }

            function setFilled($input) {
                $input.addClass('filled');
            }

            function removeFilled($input) {
                $input.removeClass('filled');
            }

            function setFocused() {
                $(this).addClass('focused');
            }

            function removeFocused() {
                $(this).removeClass('focused');
            }

            function checkInput(e) {
                if (this.type == 'button' ||
                    this.type == 'range' ||
                    this.type == 'submit' ||
                    this.type == 'radio' ||
                    this.type == 'checkbox' ||
                    this.type == 'reset') { return; }

                var $this = $(this);
                var $parent = $this.parent();
                var is_selectMenu = $parent.hasClass('select-menu') || $parent.hasClass('ginput_container_select');

                var $input = is_selectMenu ? $parent : $this;

                switch (this.type) {
                    case 'select-one':
                    case 'select-multiple':
                        if (this.value !== '') {
                            setFilled($input);
                        } else {
                            removeFilled($input);
                        }
                        break;
                    default:
                        if (this.value !== '') {
                            setFilled($input);
                        } else {
                            removeFilled($input);
                        }
                        break;
                }
            }

            $formInputs.each(checkInput);
            $formInputs.on('change', checkInput);
            $formInputs.on('focus', setFocused);
            $formInputs.on('blur', removeFocused);
            $formSelectMenus.on('focus', setFocused);
            $formSelectMenus.on('blur', removeFocused);

        }());
    }());

    //Global function top open / close lightboxes
    var PDMLightbox = (function () {

        var $body = $('body');
        //Lightbox reset - This lightbox is empty and present on all pages
        var $lightbox = $('.pdm-lightbox--reset');

        //it's content can be filled from various sources
        //after close, the content is wiped
        var $lightbox_content = $('.pdm-lightbox--reset .pdm-lightbox__content');

        $body.on('click', '[data-lightbox-iframe],[data-lightbox-content],[data-lightbox-target]', function (e) {

            e.preventDefault();

            var classes = $(this).data('lightbox-classes');
            var iframe = $(this).data('lightbox-iframe');
            var blur = $(this).data('lightbox-blur');

            if (iframe) {
                var youtubePattern = /(?:http?s?:\/\/)?(?:www\.)?youtu(be\.com\/|\.be\/)(embed\/(.+)(\?.+)?|watch\?v=(.+)(\&.+)?)/g;
                var vimeoPattern = /(?:http?s?:\/\/)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/g;

                if (youtubePattern.test(iframe)) {
                    classes += ' youtube-vid'

                    replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="//www.youtube.com/embed/$3?autoplay=1&modestbranding=1&rel=0&iv_load_policy=3" autoplay="true"/></div>';

                    iframe = iframe.replace(youtubePattern, replacement);

                }

                if (vimeoPattern.test(iframe)) {

                    classes += ' vimeo-vid'

                    replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="//player.vimeo.com/video/$3?autoplay=1&modestbranding=1&rel=0&iv_load_policy=3" autoplay="true" /></div>';

                    iframe = iframe.replace(vimeoPattern, replacement);

                }

                iframe = iframe.replace('<video ', '<video autoplay ');
                iframe = iframe.replace('<iframe ', '<iframe autoplay ');

                $lightbox_content.html('<div class="video-embed">' + iframe + '</div>');

            } else {
                if ($(this).data('lightbox-content')) {
                    var content = $(this).data('lightbox-content');
                } else if ($(this).data('lightbox-target')) {
                    var target = $(this).data('lightbox-target');
                    var content = $('#' + target).html();
                }
                $lightbox_content.html(content);
            }

            if (blur != false) {
                $body.addClass('blur');
            }

            $lightbox.addClass('active').addClass(classes);

        });

        function closeLightbox($lightbox) {
            $lightbox.removeClass('active');
            $('body').removeClass('noScroll');
            setTimeout(function () {
                $body.removeClass('blur');
            }, 250);
            //wait before removing classes till lightbox closses
            if ($lightbox.hasClass('pdm-lightbox--reset')) {
                setTimeout(function () {
                    $lightbox.find('.pdm-lightbox__content').empty();
                    $lightbox.attr('class', 'pdm-lightbox pdm-lightbox--reset');
                }, 750);
            }
        }

        $('.pdm-lightbox').on('click', function (e) {
            var $lightbox = $(this);
            if (e.target == this) {
                closeLightbox($lightbox);
            }
        });

        $('.pdm-lightbox__close').click(function (e) {
            e.stopPropagation();
            $lightbox = $(this).closest('.pdm-lightbox');
            closeLightbox($lightbox);
        });
        return {
            close: closeLightbox
        };
    }());

    //******************************************************Everything under this is optional, feel free to delete

    var Header = (function () {
        var $body = $('body');
        var $header = $('header.gheader');
        var $nav = $header.find('nav.global');
        var $adminBar = $('#wpadminbar');

        var header_height = $header.innerHeight();
        if ($adminBar.length) { header_height += $adminBar.innerHeight(); }

        if (window.innerWidth < 960) {
            $nav.css({ marginTop: header_height });
        }

        window.addEventListener('resize', function () {
            $header.css({ position: 'sticky' });
            BurgerMenu.close();

            if (window.innerWidth < 960) {
                $nav.css({ marginTop: header_height })
            } else {
                $nav.css({ marginTop: 0 });
            }
        });

        var BurgerMenu = (function () {
            var $burgerMenu = $header.find('.menu-burger');
            var $burgerSearch = $('.header-burger-search');
            var $text = $burgerMenu.find('.menu-burger__text');

            function activate() {
                $burgerMenu.addClass('active').attr('title', 'Close');
                $text.text('Close');
                $nav.addClass('active');
                $body.addClass('no-scroll');

                var styles = { position: 'fixed' };
                if ($adminBar.length) { styles.top = $adminBar.innerHeight(); }

                $header.css(styles);
                $body.css({ marginTop: $header.innerHeight() });

                if( $burgerSearch.length > 0 && $burgerSearch.hasClass('active') ) {
                    $burgerSearch.trigger('click');
                }
            }

            function reset() {
                $burgerMenu.removeClass('active').attr('title', 'Menu');
                $text.text('Menu');
                $nav.removeClass('active').find('.active').removeClass('active');
                $body.removeClass('no-scroll');

                var styles = { position: 'sticky' };
                if ($adminBar.length) { styles.top = $adminBar.innerHeight() };

                $header.css(styles);
                $body.css({ marginTop: 0 });
            }

            $burgerMenu.click(function () {
                var $this = $(this);

                if ($this.hasClass('active')) { reset(); } else { activate(); }
            });

            return {
                close: reset,
                open: activate
            }
        }());

        var BurgerSearch = (function() {
            var $burgerSearch = $('.header-burger-search'),
                $burgerMenu = $header.find('.menu-burger');
                $headerSearch = $('.gheader__search');

            function activateSearch() {
                $burgerSearch.addClass('active');
                $headerSearch.addClass('active');
                $body.addClass('no-scroll');

                if( $burgerMenu.hasClass('active') ) {
                    $burgerMenu.trigger('click');
                }

                var styles = { position: 'fixed' };
                if ($adminBar.length) { styles.top = $adminBar.innerHeight(); }
                $header.css(styles);
            }

            function closeSearch() {
                $burgerSearch.removeClass('active');
                $headerSearch.removeClass('active');
                $body.removeClass('no-scroll');

                var styles = { position: 'sticky' };
                if ($adminBar.length) { styles.top = $adminBar.innerHeight() };
                $header.css(styles);
            }

            $burgerSearch.click(function () {
                var $this = $(this);

                if ($this.hasClass('active')) { closeSearch(); } else { activateSearch(); }
            });

            return {
                open: activateSearch,
                close: closeSearch
            };
        }());

        var DropdownMenus = (function () {
            var $menus = $('.menu');
            var $dropmenus = $menus.find('.dropdown.menu-item');
            var $mobileArrow = $dropmenus.find('.mobile-arrow');

            function toggleDropdown(e) {
                e.preventDefault();

                var $this = $(this);
                var $menuItem = $this.parent();

                if ($menuItem.hasClass('active')) {
                    $menuItem.removeClass('active');
                } else {
                    $menuItem.addClass('active');
                }
            }

            $mobileArrow.click(toggleDropdown);
        }());

        var StickyHeader = (function () {
            if (!$header.hasClass('sticky')) { return; }

            if (window.scrollY) {
                $header.addClass('sticky--scrolled');
            }

            $(window).on('scroll', function () {

                if (window.scrollY) {
                    $header.addClass('sticky--scrolled');

                } else if (window.scrollY === 0) {
                    $header.removeClass('sticky--scrolled');
                }

                if ($adminBar.length) {
                    $header.css({ top: $adminBar.innerHeight() });
                }

            });
        }());

        return {
            BurgerSearch: BurgerSearch
        };
    }());

    var LoadMore = (function () {
        var $loadmore = $('#loadmore');
        if (!$loadmore.length) { return; }

        var $loadmore_text = $loadmore.text();

        $loadmore.click(function () {
            var $this = $(this);
            var $postlist = $this.siblings('.blog-posts');
            var query = WP.query;
            var page = WP.current_page;
            var max = WP.max_page;

            var data = {
                action: 'load_more_posts',
                query: query,
                page: page
            };

            $.ajax({
                url: ajaxURL,
                type: 'post',
                data: data,
                beforeSend: function () {
                    $loadmore.attr('disabled', true).text('Loading Posts');
                },
                error: function (res) {
                    res = JSON.parse(res);
                    console.log(res);
                },
                success: function (posts) {
                    if (posts) {
                        page = WP.current_page++;
                        $loadmore.attr('disabled', false).text($loadmore_text);
                        $postlist.append(posts);
                        LazyLoading.update();

                        if (WP.current_page >= max) { $loadmore.remove(); }
                    } else {
                        $loadmore.remove();
                    }
                }
            });
        });
    }());

    var JobSearch = (function () {
        var $form = $('.job-search');
        if (!$form.length) { return; }

        if (window.innerWidth > 720) { $form.find('select[multiple]').select2({ placeholder: "Select a state" }); }

        var $discipline = $form.find('#discipline');
        var $specialties = $form.find('#specialty');

        $discipline.change(function () {
            var selected = this.selectedOptions[0];

            var specialties = selected.value !== '' ? JSON.parse(selected.dataset.specialties) : [];
            var newDropdown = '<option value="">Select Option</option>';

            $specialties.prop('disabled', true);

            if (specialties.length) {

                $.each(specialties, function (i, spec) {
                    newDropdown += '<option value="' + spec.value + '">' + spec.label + '</option>';
                });
                $specialties.prop('disabled', false);

            } else {
                newDropdown = '<option value="">No options available</option>';
            }

            $specialties.html(newDropdown);
        });
    }());

    var GravityForm_JobFields = (function () {
        var $form = $('.gform_wrapper');
        if (!$form.length) { return; }

        var $specialites = $form.find('.select-specialty select');
        var $specialites_default_option = '<option value="">Select an option</option>';

        $specialites.html($specialites_default_option).val('');

        $form.find('.select-discipline select').change(function (e) {
            $specialites.attr('disabled', true);

            var data = {
                action: 'getSpecialites',
                discipline: this.value
            };

            $.ajax({
                url: ajaxURL,
                type: 'post',
                data: data,
                error: function (res) {
                    $specialites.attr('disabled', false);
                    res = JSON.parse(res);
                    console.log(res);
                },
                success: function (res) {
                    res = JSON.parse(res);

                    var has_specialties = res.total_specialties > 0;

                    $specialites.val('')
                        .attr('disabled', !has_specialties)
                        .prop('required', has_specialties)
                        .html(res.specialites)
                        .trigger('change');
                }
            });
        })
    }());

    var TestimonialsCTASlider = (function () {
        var $section = $('.cta-testimonials');
        if (!$section.length) { return; }

        var $slider = $section.find('.slider');
        var $slides = $slider.find('.slider__slide');

        $slider.on('ready.flickity', function (e) {
            if ($slides.length <= 1) {
                $slider.find('.flickity-page-dots').hide();
            }
        });

        $slider.flickity({
            contain: true,
            prevNextButtons: false
        });

        jQuery('.swiper-faqs').flickity({
        cellAlign: 'left',
                contain: true,
                groupCells: 1,
                wrapAround: true
        });

        jQuery('.swiper-faqs').flickity('resize');
        var options = {
            groupCells: false,
            groupCells: 1,
        };
        
        // Change when larger screen is loaded
        if ( matchMedia('screen and (max-width: 768px)').matches ) {
            options.groupCells = true;
            options.groupCells = 1;
        }
        
        
        jQuery('.swiper-faqs').flickity( options );

        jQuery('.carousel-cell .read-more').on('click',function(){
        jQuery(this).parent().toggleClass('active');
        if (jQuery(this).text() == 'Read More') {
            jQuery(this).text('Read Less')
        } else {
            jQuery(this).text('Read More')
        }
        var flkty = new Flickity('.swiper-faqs');
        flkty.resize();
        });

    }());

    var featDestinations = (function () {

        var $nav = $('.feat-des__nav');
        var $navBtns = $('.feat-des__nav button');

        if (!$navBtns.length) { return; }

        var $destinations = $('.feat-des__cards .imglink-card')

        $nav.flickity({
            contain: true,
            prevNextButtons: false,
            cellAlign: 'left',
            groupCells: true,
            pageDots: false,
            prevNextButtons: $nav.find('.flickity-slider button').length <= 8
        });

        $navBtns.click(function () {

            var $this = $(this);
            var id = $this.data('target');

            $navBtns.removeClass('active');
            $destinations.removeClass('active');

            $this.addClass('active');
            $destinations.filter('[data-card-id="' + id + '"]').addClass('active');

        });

    }());

    var TopDestinations = (function () {
        var $section = $('.top-destinations');
        if (!$section.length) { return; }
    }());

    var Filterable = (function () {
        var $section = $('.filterable');
        if (!$section.length) { return; }

        var $triggers = $section.find('.filterable__triggers .btn');
        var $content = $section.find('.filterable__content');

        $triggers.click(function () {
            var ID = this.dataset.id;

            $triggers.removeClass('active').filter(this).addClass('active');

            if (ID == 'all') {
                $content.removeClass('hidden');
            } else {

                $content.addClass('hidden').filter(function (i, el) {
                    var ids;
                    if(el.dataset.id !== undefined) {
                        ids = el.dataset.id;
                    }

                    if (ids !== undefined && ids.indexOf(ID) >= 0) {
                        $(el).removeClass('hidden');
                    }
                });
            }
        });
    }());

    var TabSlider = (function () {
        var $section = $('.tabslider');
        if (!$section.length) { return; }

        var $slider = $section.find('.slider');
        $slider.flickity({
            contain: true,
            prevNextButtons: false,
            pageDots: false
        });

        var $tabs = $section.find('.tabslider__tabs .btn');
        $tabs.click(function () {
            $tabs.removeClass('active').filter(this).addClass('active');
            $slider.flickity('select', $(this).index());
        });
    }());

    var PostSlider = (function () {
        var $section = $('.postslider');
        if (!$section.length) { return; }

        var $slider = $section.find('.slider');
        $slider.flickity({
            contain: true,
            prevNextButtons: false,
            pageDots: false
        });
    }());

    var JobsList = (function () {
        var $section = $('.jobresults');
        if (!$section.length) { return; }

        var $loadmore = $section.find('.jobslist__more');
        var loadmore_text = $loadmore.text();
        
        var job_params = JSON.parse($section.attr('data-params'));
        var job_limit = parseInt($section.attr('data-limit'));
        var job_page = parseInt($section.attr('data-page'));

        var $job_list = $section.find('.jobslist__list');

        if( $loadmore.attr('data-infinitescroll') == 'true' ) {
            var scrollObserver = new IntersectionObserver(function(entries) {
                if(entries[0].isIntersecting === true) {
                    if( $loadmore.attr('disabled') === undefined  ) {
                        $loadmore.trigger('click');
                    }
                }
            }, { threshold: [1] });
            scrollObserver.observe( $loadmore.get(0) );
        }

        $loadmore.click(function () {
            var $this = $(this);
            $this.attr('disabled', true).text('Loading more...');

            job_page = job_page + 1;
            job_params.offset = job_page * job_limit;

            var data = {
                action: 'getMoreJobs',
                params: JSON.stringify(job_params),
                offset: job_params.offset,
            };

            $.ajax({
                url: ajaxURL,
                type: 'post',
                data: data,
                error: function (res) {
                    $this.attr('disabled', false).text(loadmore_text);
                    res = JSON.parse(res);
                    console.log(res);
                },
                success: function (res) {
                    $this.attr('disabled', false).text(loadmore_text);
                    res = JSON.parse(res);

                    /*console.log(res);*/
                    $section.attr('data-page', job_page);
                    $job_list.append(res.jobs);

                    if (parseInt($section.attr('data-page')) >= parseInt($section.attr('data-total-pages'))) {
                        $this.hide();
                    }

                }
            });
        });
    }());

    var TabAcordions = (function () {
        var $section = $('.tabaccordions');
        if (!$section.length) { return; }

        var $tabs = $section.find('.tabaccordions__tabs button');
        var $content = $section.find('.tabaccordions__accordion');

        $tabs.click(function () {
            $tabs
                .removeClass('active')
                .filter('[data-tab="' + this.dataset.tab + '"]')
                .addClass('active');
            $content
                .removeClass('active')
                .filter('[data-tab="' + this.dataset.tab + '"]')
                .addClass('active');
        });
    }());

    var JobSearchFfilter = (function () {
        var $form = $('.job-search-form');
        if (!$form.length) { return }

        var $searchForm = $form.find('form');

        $form.find('[type="button"]').click(function () {
            var $this = $(this);

            if ($this.hasClass('active')) {
                $this.removeClass('active').find('.btn-text').text('Show Filters');
                $searchForm.slideUp();
            } else {
                $this.addClass('active').find('.btn-text').text('Hide Filters');
                $searchForm.slideDown();
            }
        });
    }());

    var JobSearchForm = (function () {
        var $form = $('.job-search');
        if (!$form.length) { return; }

        var $sortSelect = $('#sort');
        var $licenseStateCompact = $('#licenseStateCompact');
        var $destination_search = $('#destination_search');

        // Enable destination search by default
        //$destination_search.removeClass('disabled');
        //$('#address-autocomplete').removeAttr('disabled');

        // Disable destination search when compact states is checked
        $licenseStateCompact.on('change', function () {
           $('#address-autocomplete').val("").prop('disabled', this.checked).parent().toggleClass('disabled', this.checked);
        });

        $sortSelect.change(function () {
            $('#sort_by').val(this.value);
            $form.find('[type="submit"]').trigger('click');
        });

        $form.find('[type="submit"]').click(function (e) {
            e.preventDefault();

            $form.find('[type="submit"]').val('Searching').attr('disabled', true);

            var form_action = '/jobs';
            var $discipline = $('#discipline').val();
            var $specialty = $('#specialty').val();
            var $state = $('#state').val();
            var $city = $('#city').val();
            var $sortBy = $('#sort_by').val();
            var $exclusive = $('#exclusive').is(':checked') ? $('#exclusive').val() : false;
            var $licenseStateCompact = $('#licenseStateCompact').is(':checked') ? $('#licenseStateCompact').val() : false;
            var $jobType = $('#job-type').val();

            console.log($licenseStateCompact);

            if ($state !== undefined && $state !== '') {
                form_action += '/destination/' + $state;
            }

            if ($city !== undefined && $city !== '') {
                form_action += '/city/' + $city;
            }

            if ($discipline !== undefined && $discipline !== '') {
                form_action += '/discipline/' + $discipline;
            }

            if ($specialty !== undefined && $specialty !== '') {
                form_action += '/specialty/' + $specialty;
            }

            if ($sortBy !== undefined && $sortBy !== '') {
                form_action += '/sort_by/' + $sortBy;
            }

            if ($exclusive) {
                form_action += '/exclusive/' + $exclusive;
            }

            if ($licenseStateCompact) {
                form_action += '/licenseStateCompact/' + $licenseStateCompact;
            }

            if ($jobType) {
                form_action += '/jobType/' + $jobType;
            }

            console.log(form_action);

            form_action += '/';

            var eventData = {
                discipline: $discipline,
                specialty: $specialty,
                exclusive: $exclusive,
                licenseStateCompact: $licenseStateCompact,
                destination: ($city !== '') ? $city + ', ' + $state : $state,
                jobType: $jobType
            };

            window.host.trackSearch(eventData).then(() => {
                $form.attr('action', encodeURI(form_action)).submit();
            });
        });
    }());

    var PlacesAutocomplete = (function () {

        var input = document.querySelector('#address-autocomplete');
        if (!input) { return; }

        var $input = $(input);
        var $city = $('#city');
        var $state = $('#state');

        var options = {
            componentRestrictions: { country: "us" },
            fields: ['address_components'],
            types: ['(regions)']
        };

        var autocomplete = new google.maps.places.Autocomplete(input, options);

        autocomplete.addListener('place_changed', function () {
            var place = autocomplete.getPlace();

            $city.val('');
            $state.val('');

            console.log(place);

            // $city.val(place['address_components'][0].long_name.replace('County', '').trim());
            // $state.val(place['address_components'][2].long_name);

            place['address_components'].forEach(function (i) {
                switch (i.types[0]) {
                    case 'locality':
                        $city.val(i.long_name.replace('County', '').trim());
                        break;
                    case 'administrative_area_level_1':
                        $state.val(i.long_name);
                        break;
                    case 'country':
                        break;
                }
            });

            if ($state.val() !== '' && $city.val() == '') {
                $input.val($state.val());
            } else {
                $input.val($city.val() + ', ' + $state.val());
            }
        });

        $input.on('keypress', function (e) {
            var $autocomplete_searchbox = $('.pac-container');

            setTimeout(function () {

                $autocomplete_searchbox.css({ marginTop: -($autocomplete_searchbox.innerHeight() + 86) });
            }, 500);

        });

    }());

    var MobileAppSlider = (function () {

        var $section = $('.contentsteps__slider');
        if (!$section.length) { return; }

        console.log("contentsteps__slider slider");

        var $slider = $section.find('.contentsteps__steps');
        $slider.flickity({
            contain: true,
            prevNextButtons: true,
            pageDots: true,
            adaptiveHeight: true
        });

    }());

    var LoadJobLink = (function ($) {
        var $job_links = $('.job-link');
        var jobid = $job_links.data('jobid');

        if (!$job_links.length) { return; }

        setTimeout(async function () {
            await window.host.getJobLink(jobid)
                .then(function (job_link) { return $job_links.attr('href', job_link) });
        }, 2500);

    }(jQuery));

    var inputRange = (function ($) {

        var $counter = $("#counter");
        if (!$counter.length) { return; }

        $counter.change(function () {
            $num = $(this).val();
            $slide = $(".tslide" + $num);
            $(".tslide").removeClass("active");
            $slide.addClass("active");
        });

    }(jQuery));

    var rangeSlider = (function ($) {

        var $carousel = $('.main-carousel');
        if (!$carousel.length) { return; }

        $carousel.flickity({
            // options
            wrapAround: true,
            autoPlay: 2000,
            pauseAutoPlayOnHover: false,
            prevNextButtons: false
        });

    }(jQuery));

    var PrivacyPolicyAcknowledgement = (function () {
        var $ppa = $('.ppa');
        if (!$ppa.length) { return; }

        var $checkbox = $ppa.find('#ppa_check');

        console.log(Cookie.get('ppa_checked'));

        if (Cookie.get('ppa_checked') !== undefined) {
            $ppa.remove();
        }

        $checkbox.change(function () {
            $ppa.css('transform', 'translate(0, 100%)');

            Cookie.set('ppa_checked', true);
            setTimeout(function () {
                $ppa.remove();
            }, 2000);

        });
    }());

    var SignUpForm = (function () {
        $(document).on('gform_post_render', function (e, id, page) {
            jQuery('.swiper-faqs').flickity({
                cellAlign: 'left',
                        contain: true,
                        groupCells: 1,
                        wrapAround: true
                });
        
               jQuery('.swiper-faqs').flickity('resize');
               console.log('ejecuto');
               var options = {
                 groupCells: false,
                 groupCells: 1,
               };
             
               // Change when larger screen is loaded
               if ( matchMedia('screen and (max-width: 768px)').matches ) {
                 options.groupCells = true;
                 options.groupCells = 1;
               }
             
             
               jQuery('.swiper-faqs').flickity( options );

               jQuery('.carousel-cell .read-more').on('click',function(){
                jQuery(this).parent().toggleClass('active');
                if (jQuery(this).text() == 'Read More') {
                    jQuery(this).text('Read Less')
                } else {
                    jQuery(this).text('Read More')
                }
                var flkty = new Flickity('.swiper-faqs');
                flkty.resize();
            });
            
            // console.clear();
            if (id == 3) {
                var $gform = $('#gform_wrapper_3');
                if (!$gform.length) { return; }

                var $form = $gform.find('form');

                if ($gform.hasClass('gform_validation_error') || $gform.hasClass('gform_confirmation_wrapper')) {

                    var $discipline = $form.find('#input_3_5').val();
                    var $specialty = $form.find('#input_3_4').val();
                    var $years = $form.find('#input_3_24').val();
                    var $hear_about_us = $form.find('#input_3_6').val();
                    var $referral_name = $form.find('#input_3_16').val();
                    var $referral_relationship = $form.find('#input_3_15').val();
                    var $fname = $form.find('#input_3_9').val();
                    var $lname = $form.find('#input_3_10').val();
                    var $phone = $form.find('#input_3_11').val();
                    var $email = $form.find('#input_3_12').val();
                    var $password = $form.find('#input_3_22').val();
                    var $comfirm_password = $form.find('#input_3_23').val();

                    var $track_status = $gform.hasClass('gform_confirmation_wrapper') ? 'SIGNUP_LANDING_SUCCESS' : 'SIGNUP_LANDING_FAILED';

                    host.trackEvent($track_status, {
                        discipline: $discipline,
                        specialty: $specialty,
                        years_of_experience: $years,
                        acquisition_channel: $hear_about_us,
                        referral_name: $hear_about_us == 'referral' ? $referral_name : null,
                        referral_relationship: $hear_about_us == 'referral' ? $referral_relationship : null,
                        first_name: $fname,
                        last_name: $lname,
                        phone_num: $phone,
                        email: $email,
                        event_date: new Date().toISOString()
                    });
                }
            }
        });
    }());

    var JobFilter = (function () {
        var $exclusive_wrap = $('.exclusive-wrap');
        if (!$exclusive_wrap.length) { return; }

        // Function to handle element repositioning based on screen width
        function repositionElements() {
            var $windowWidth = $(window).width();
            var $exclusiveBot = $(".exclusive-bot");
            var $exclusive_before = $(".exclusive-before");

            if ($windowWidth < 960) {
                // Insert before the first element with the class "exclusive-bot"
                $exclusive_wrap.insertBefore($exclusiveBot.first());
            } else {
                // Insert after the element with the class "select-menu"
                $exclusive_wrap.insertAfter($exclusive_before);
            }
        }

        // Initial call to set element positions on page load
        repositionElements();

        // Event listener for window resize
        $(window).on("resize", function () {
            repositionElements();
        });
    }());

    var JobSearchExtended = (function () {
        var jobOpts = jQuery('.jbs-opts-mob');
        if( jobOpts.length == 0 ) { return; }

        // mobile visual for checkboxes triggers click on real elements
        jQuery(document).on('click', '.jbs-opts-mob .jbs-checkbox', function(e) {
            var target = jQuery(e.target);
            if( !target.hasClass('jbs-checkbox')  ) {
              target = target.closest('.jbs-checkbox');
            }

            var srcSelector = target.attr('data-target');
            if( srcSelector ) {
              if( jQuery('#' + srcSelector).is(':checked') ) {
                jQuery(this).removeClass('is-checked');
              }
              else {
                jQuery(this).addClass('is-checked');
              }
              jQuery('#' + srcSelector).trigger('click');
            }
        });
    }());

    var FaqsSlider = (function() {

        var faqsSection = jQuery('.faqs-section-test');
        if( faqsSection.length == 0 ) { return; }

        const items = document.querySelectorAll('.faqs-section-test .accordion button');

        function toggleFaqsAccordion() {
            const itemToggle = this.getAttribute('aria-expanded');

            for (i = 0; i < items.length; i++) {
                items[i].setAttribute('aria-expanded', 'false');
            }
            if (itemToggle == 'false') {
                this.setAttribute('aria-expanded', 'true');
            }
        }
        items.forEach((item) => item.addEventListener('click', toggleFaqsAccordion));

        jQuery('.faqs-section-test .swiper-faqs').flickity({
            cellAlign: 'left',
            contain: true,
            groupCells: 1,
            wrapAround: true
        });

        jQuery('.faqs-section-test .swiper-faqs').flickity('resize');
        var options = {
            groupCells: false,
            groupCells: 1,
        };
        
        // Change when larger screen is loaded
        if ( matchMedia('screen and (max-width: 768px)').matches ) {
            options.groupCells = true;
            options.groupCells = 1;
        }
        jQuery('.faqs-section-test .swiper-faqs').flickity( options );

        jQuery('.faqs-section-test .faqs__carousel-cell .read-more').on('click',function(){
            jQuery(this).parent().toggleClass('active');
            if (jQuery(this).text() == 'Read More') {
                jQuery(this).text('Read Less')
            } else {
                jQuery(this).text('Read More')
            }
            jQuery('.swiper-faqs').flickity('resize');
        });

        setTimeout(() => {
            jQuery('.faqs-section-test .swiper-faqs').flickity('resize');
    
            jQuery('.faqs-section-test .flickity-button').on('click',function(){
                jQuery('.faqs__carousel-cell').removeClass('active');
                jQuery('.swiper-faqs').flickity('resize');
                jQuery('.faqs__carousel-cell .read-more').text('Read More');
            })
        }, "1000");
    }());

    var JobSearchOnTop = (function() {

        var jobsFormFilters = jQuery('.template-jobsearch .job-search-form-wrap');
        if( jobsFormFilters.length == 0 ) { return; }

        var jobFormTop = -1,
            jobsHeaderHeight = -1,
            lastScrollTop = -1;

        setTimeout(() => {
            captureJobFormSettings();
        }, 500);

        jQuery(window).scroll(function(e) {
            repositionJobForm(e);
            lastScrollTop = jQuery(window).scrollTop();
        });
        jQuery(window).resize(function() {
            jobFormTop = -1;
            jobsHeaderHeight = -1;
            lastScrollTop = -1;
            captureJobFormSettings();
        });

        function captureJobFormSettings() {
            if( jobFormTop == -1 ) {
                jobFormTop = jQuery('.job-search-form-wrap').offset().top;
            }
            if( jobsHeaderHeight == -1 ) {
                jobsHeaderHeight = jQuery('.gheader').outerHeight();
            }
            if( lastScrollTop == -1 ) {
                lastScrollTop = jQuery(window).scrollTop();
            }
            var headerTopHeight = jQuery('.gheader .gheader-top').outerHeight();
            document.documentElement.style.setProperty('--gheader-top-height', `-${headerTopHeight}px`);
        }

        function repositionJobForm( e ) {
            captureJobFormSettings();

            var windowScrollTop = jQuery(window).scrollTop();
                scrollDirection = 'down',
                header = jQuery('.gheader');

            if( windowScrollTop < lastScrollTop ) {
                scrollDirection = 'up';
            }

            /** Jobs Form */
            // Depth of scroll to collapse the filter form
            let scrollDepth = 0;
            if (window.innerWidth < 768) {
                scrollDepth = 450;
            } else {
                scrollDepth = 40;
            }
            
            if( windowScrollTop + jobsHeaderHeight > (jobFormTop + scrollDepth) ) {
                if( jQuery('.job-search-form').hasClass('job-search-form--inline') ) {
                    jQuery('.job-search-form').removeClass('job-search-form--inline');
                    closeMobileFilters();
                }
            }
            else if( !jQuery('.job-search-form').hasClass('job-search-form--inline') ) {
                jQuery('.job-search-form').addClass('job-search-form--inline');
                closeMobileFilters();
            }

            /** Header repositioning */
            if( scrollDirection == 'down' ) {
                if(  windowScrollTop + jobsHeaderHeight > (jobFormTop - 40) && !header.hasClass('gheader--hidden')  ) {
                    header.addClass('gheader--hidden');
                    header.removeClass('gheader--middle');
                    jQuery('.job-search-form').removeClass('job-search-form--state2');
                }
            }
            else { /** scroll direction to top */

                header.addClass('gheader--middle');
                header.removeClass('gheader--hidden');
                jQuery('.job-search-form').addClass('job-search-form--state2');
                
                if ( windowScrollTop + jobsHeaderHeight < (jobFormTop - 40 ) ) {
                    if( header.hasClass('gheader--hidden') || header.hasClass('gheader--middle') ) {
                        header.hasClass('gheader--hidden') && header.removeClass('gheader--hidden');
                        header.hasClass('gheader--middle') && header.removeClass('gheader--middle');
                        jQuery('.job-search-form').removeClass('job-search-form--state2');
                    }
                }
            }
        }

        function closeMobileFilters() {
            if( jQuery('.job-search-form .btn[data-id="toggle-filters"].active').length > 0 ) {
                jQuery('.job-search-form .btn[data-id="toggle-filters"]').trigger('click');
            }
        }

    }());

    var SignupPostSubmission = (function() {

        var signup_page = jQuery('body.pid-416');
        if( signup_page.length == 0 ) { return; }

        jQuery(document).on('gform_confirmation_loaded', function(event, formId) {
            if( typeof site.signup_thankyou_url !== 'undefined' ) {
              window.location.href = site.signup_thankyou_url;
            }
        });

    }());

    var SignupThankyouEvent = (function() {
        var signup_thankyou = jQuery('body.template-thank-you');
        if( signup_thankyou.length == 0 ) { return; }

        jQuery(document).on('click','.menu-item-complete_application >a, #complete_application', function(e) { 

            e.preventDefault();
            dataLayer.push({'event': 'signup_complete_application'});
            var url = this.getAttribute('href');
            window.open(url, '__blank');

        });
    }());

    var searchFilterRunning = false;

    var SearchResults = (function() {
        var searchPage = jQuery('body.search');
        if( searchPage.length == 0 ) { return; }

        jQuery(document).on( 'click', '.sfilters [data-filter]', function(e) {
            
            e.preventDefault(); 
            var filter = jQuery(this).data('filter'),
                parent = jQuery(this).closest('.sfilters'),
                count = parseInt(jQuery(this).attr('data-count'));

            jQuery('.sfilters__item').removeClass('is-active');
            jQuery(this).closest('.sfilters__item').addClass('is-active');
            jQuery('.sresults').attr('data-filter', filter);

            if( 'job' !== filter ) {
                if( count >= 9 ) {
                    jQuery('#search-loadmore').removeClass('hidden');
                }
                else {
                    jQuery('#search-loadmore').addClass('hidden');
                }
                jQuery('#search-loadmore-jobs').addClass('hidden');
            }
            else {
                jQuery('#search-loadmore').addClass('hidden');
                jQuery('#search-loadmore-jobs').removeClass('hidden');
            }

        });

        jQuery('#search-loadmore').on('click', function(e) {
            e.preventDefault();
            var term = document.querySelector('.results-section').getAttribute('data-term');
            var currentPage = parseInt(jQuery('.sresults').attr('data-page')) || 1;
            var totalPages = parseInt( document.querySelector('.results-section .sresults').getAttribute('data-total-pages') );
            
            var data = {
                action: 'search_load_more', 
                page: currentPage,  
                limit: jQuery('.sresults').attr('data-limit'),
                term: term 
            };
    
            jQuery.ajax({
                url: ajaxURL,
                type: 'post',
                data: data,
                dataType: 'json',
                beforeSend: function () {
                    jQuery('#search-loadmore').attr('disabled', true).text('Loading more...');
                },
                error: function (res) {
                    res = JSON.parse(res);
                    console.error(res);
                    jQuery('#search-loadmore').hide();
                },
                success: function (response) {
                    if (response.success) {
                        currentPage = currentPage + 1;
                        jQuery('.sresults').append(response.html);
                        jQuery('.sresults').attr('data-page', ''+currentPage);
                        
                        if (currentPage >= totalPages) {
                            jQuery('#search-loadmore').hide();
                        } else {
                            jQuery('#search-loadmore').attr('disabled', false).text('Load More');
                        }
                    } else {
                        jQuery('#search-loadmore').hide();
                    }
                }
            });
            
        });

        var loadMoreButton = jQuery("#search-loadmore-jobs");
        
        if (loadMoreButton.length === 0) return;
    
        var isLoading = false;
    
        jQuery(window).on("scroll", function () {
            if (isLoading) return;
    
            var rect = loadMoreButton[0].getBoundingClientRect();
            var windowHeight = window.innerHeight;
    
            if (rect.top <= windowHeight + 100) {
                
                if(searchFilterRunning === false) {
                    loadMoreJobs();
                }
            }
        });

        jQuery('#search-loadmore-jobs').on('click', function(e) {
            e.preventDefault();
            loadMoreJobs();
        });

        function loadMoreJobs() {
            if (loadMoreButton.disabled) return;

            isLoading = true;

            var text = document.querySelector('.results-section').getAttribute('data-term');
            var offset = parseInt(jQuery('.sfilters a[data-filter="job"]').attr('data-count')) || 0;
            var totalCount = parseInt(jQuery('.sfilters a[data-filter="job"]').attr('data-total'));
            
            var select = document.querySelector('.c-dropdown__select');

            var data = {
                action: 'searchMoreJobs', 
                offset: offset,
                s: text
            };
            
            if (select && select.value != -1) {
                data.filters = [
                    {
                        type: 'state',
                        value: select.value
                    }
                ];
            }
    
            jQuery.ajax({
                url: ajaxURL,
                type: 'post',
                data: data,
                dataType: 'json',
                beforeSend: function () {
                    jQuery('#search-loadmore-jobs').attr('disabled', true).text('Loading more...');
                },
                error: function (res) {
                    console.error(res);
                    jQuery('#search-loadmore-jobs').hide();
                    isLoading = false;
                },
                success: function (response) {
                    if (response.success) {
                        totalCount = response.totalCount;
                        offset = offset + parseInt(response.data.length);
    
                        $('.sfilters a[data-filter="job"]').attr('data-total', totalCount);
                        jQuery('.sfilters a[data-filter="job"]').attr('data-count', '' + offset);
    
                        jQuery('.sresults').append(response.html);
    
                        if (offset >= totalCount) {
                            jQuery('#search-loadmore-jobs').hide();
                        } else {
                            jQuery('#search-loadmore-jobs').attr('disabled', false).text('Load More');
                        }

                        isLoading = false;
                    } else {
                        jQuery('#search-loadmore-jobs').hide();
                        isLoading = false;
                    }
                }
            });
        }
    }());

    var JobsResults = (function() {
        var jobs_slider = jQuery('div[data-id="jobs_slider"]');
        if (jobs_slider.length == 0) { return; }
    
        function initializeSlider(slider) {
            if (slider.length === 0) return;

            slider.flickity({
                cellAlign: 'left',
                contain: true,
                prevNextButtons: true,
                wrapAround: true,
                pageDots: false 
            });
            slider.flickity('resize');
            
            jQuery(window).resize(function() {
                slider.flickity('resize');
            });
        }
        jQuery(document).on('update_job_results', function(e, newHTML, slider) {
            if (!slider || slider.length === 0) return;

            if (slider && slider.length > 0) {
                slider.flickity('destroy'); 
                slider.empty();
            }
            slider.html(newHTML); 
            initializeSlider(slider);
        });

        jobs_slider.each(function() {
            initializeSlider(jQuery(this));
        }); 
    }());

    var JobResultsFilter = (function() {
        var jobs_with_filters = jQuery('section[data-id="job_results_filter"]');
        if (jobs_with_filters.length == 0) { return; }

        jobs_with_filters.each(function() {
            var cache = {};
            var jobs_results = jQuery(this);
            var limit = jobs_results.find('.job-results__slider-wrap').data('limit');
            var slider = jobs_results.find('.jobs-slider[data-id="jobs_slider"]');

            jobs_results.on('click', '.filters-tags .filters-tags__item', function(e) {
                e.preventDefault();
                var target = jQuery(e.currentTarget),
                    parent = target.parent(),
                    type = target.data('type'),
                    value = target.data('value');

                parent.find('.filters-tags__item').removeClass('is-active'); 
                target.addClass('is-active');
                loadTagData(limit, type, value);
            });

            function loadTagData(limit, type, value) {
                if (cache[value]) {
                    jQuery(document.body).trigger('update_job_results', [ cache[value], slider ]);
                }else {
                    var data = {
                        action: 'getJobResults',    
                        limit,
                        type,
                        value
                    };
                    jQuery.ajax({
                        url: ajaxURL,
                        type: 'post', 
                        data: data,
                        beforeSend: function() {
                            jobs_results.find('.job-results__slider-wrap, .filters-tags__item').addClass('ajax-loading');
                        },
                        error: function (res) {
                            console.log(res);
                            jobs_results.find('.job-results__slider-wrap, .filters-tags__item').removeClass('ajax-loading');
                        },
                        success: function (res) {                 
                            if (res && res.data && res.data.html) {  
                                if(value) {
                                    cache[value] =  res.data.html;
                                }            
                                jQuery(document.body).trigger('update_job_results', [res.data.html, slider]);
                            }
                            jobs_results.find('.job-results__slider-wrap, .filters-tags__item').removeClass('ajax-loading');
                        }
                    });
                }
            };
        });

    }());
    
    var ExitIntent = (function() {
            
        var triggerB = document.getElementById('btn_exitintent');

        if( !triggerB ) { return; }

        var os = navigator.userAgent.indexOf('Macintosh') !== -1 || navigator.userAgent.indexOf('Mac OS X') !== -1 ? 'Mac' : 'Other';

        document.addEventListener('mouseleave', function(event) {
            var mouseX = event.clientX; 
            var mouseY = event.clientY; 
            var widthThreshold = window.innerWidth * 0.27;
            var heightThreshold = 25;
        
            if ((os === 'Mac' && mouseX <= widthThreshold && mouseY <= heightThreshold) || 
                (os === 'Other' && mouseX >= window.innerWidth - widthThreshold && mouseY <= heightThreshold)) {
                handleExitIntent();
            }
        });

        document.addEventListener('visibilitychange', function() {
            if (navigator.userAgent.toLowerCase().indexOf('iphone') !== -1 || navigator.userAgent.toLowerCase().indexOf('android') !== -1) {
                if (document.hidden) {
                    handleExitIntent();
                }
            }
        });

        function handleExitIntent() {
            var cookieValue = Cookie.get('job-intent-popup');
            if(!cookieValue) {
                openLightboxInline(triggerB);
                Cookie.set('job-intent-popup', 1, 365 * 2, '/');
            }
        }

        function openLightboxInline(triggerBtn) {
            var $body = jQuery('body');
            var $lightbox = jQuery('.pdm-lightbox--reset');

            var $lightbox_content = jQuery('.pdm-lightbox--reset .pdm-lightbox__content');

            var classes = $(triggerBtn).data('lightbox-classes');
            var iframe = $(triggerBtn).data('lightbox-iframe');
            var blur = $(triggerBtn).data('lightbox-blur');

            if (jQuery(triggerBtn).data('lightbox-content')) {
                var content = jQuery(triggerBtn).data('lightbox-content');
            } else if ($(triggerBtn).data('lightbox-target')) {
                var target = jQuery(triggerBtn).data('lightbox-target');
                var content = jQuery('#' + target).html();
            }
            $lightbox_content.html(content);

            if (blur != false) {
                $body.addClass('blur');
            }

            $lightbox.addClass('active').addClass(classes);
        }

        jQuery(document).on('click', '.pdm-lightbox__btn-close', function (e) {
            e.stopPropagation();
            $lightbox = $(this).closest('.pdm-lightbox');
            $lightbox.find('.pdm-lightbox__close').trigger('click');
        });

    }());

    var ValuePropsSlider = (function() {

        var slider = jQuery('div[data-id="ivp_slider"]');

        if (slider.length == 0) { return; }
    
        slider.flickity({
            cellAlign: 'center',
            contain: true, 
            prevNextButtons: true,
            wrapAround: false,
            pageDots: true,
            groupCells: true,
        });
        
        slider.flickity('resize'); 

        jQuery(window).resize(function() {
            slider.flickity('resize');
        });

    }());

    var PopupDestinations = (function() {
        var triggerPopup = document.querySelector('#btn_dest_popup');
        var openPopup = document.querySelector('#open_dest_popup');
        var desktopWidth = 960; 

        if (!triggerPopup || !openPopup) { return; }
     
        function openLightboxInline(triggerBtn) {
            var $body = jQuery('body');
            var $lightbox = jQuery('.pdm-lightbox--reset');
            var $lightbox_content = jQuery('.pdm-lightbox--reset .pdm-lightbox__content');
            var classes = $(triggerBtn).data('lightbox-classes');

            if (jQuery(triggerBtn).data('lightbox-content')) {
                var content = jQuery(triggerBtn).data('lightbox-content');
            } else if ($(triggerBtn).data('lightbox-target')) {
                var target = jQuery(triggerBtn).data('lightbox-target');
                var content = jQuery('#' + target).html();
            }
            $lightbox_content.html(content);

            $lightbox.addClass('active').addClass(classes);

            jQuery(document.body).trigger('cdropdown_loaded');
        }

        function handleResize() {
            if (window.innerWidth >= desktopWidth) {
                closePopup();
            }
        }
    
        function closePopup() {
            var $lightbox = jQuery('.pdm-lightbox--reset');
            $lightbox.find('.pdm-lightbox__close').trigger('click');
        }
    
        openPopup.addEventListener("click", function (event) {
            event.preventDefault(); 
            openLightboxInline(triggerPopup);
        });

        window.addEventListener('resize', handleResize);

        handleResize();

    }());

    var CDropdown = (function() {
        var cDropdown = document.querySelector('.c-dropdown');

        if (!cDropdown) { return; }

        jQuery(document).on('cdropdown_loaded', function(e, newHTML) {
            setTimeout(function() {
                jQuery('.c-dropdown__field').focus();
            }, 200);
        });

        jQuery(document).on('click', '.c-dropdown .c-dropdown__head__close', function (event) {
            jQuery('.c-dropdown').toggleClass('open');
        });

        jQuery(document).on('click', '.c-dropdown .c-dropdown__list-wrap .c-dropdown__list a, .c-dropdown .c-dropdown__list-wrap .c-dropdown__list li', function () {
            var option = jQuery(this).clone();
            option.find('span').remove(); 
            var display = jQuery.trim(option.text());
            if (display.includes('|')) {
                display = display.replace(/\s*\|\s*/g, ' | '); 
            }
            var dropdown = jQuery(this).closest('.c-dropdown');
            dropdown.find('.c-dropdown__head .c-dropdown__field').val(display);
            dropdown.removeClass('open'); 
        });

        jQuery(document).on('input', '.c-dropdown .c-dropdown__field', function () {
            var searchText = jQuery(this).val().toLowerCase();
            var hasResults = false;
        
            jQuery(this).closest('.c-dropdown').find('.c-dropdown__list a, .c-dropdown__list li').each(function () {
                var optionText = jQuery(this).text().replace(/\s+/g, ' ').trim().toLowerCase();
                var isMatch = optionText.includes(searchText);
                jQuery(this).toggle(isMatch);
                if (isMatch) {
                    hasResults = true;
                }
            });
        
            if (hasResults) {
                jQuery('.no-results').hide();
            } else {
                jQuery('.no-results').show();
            }
        });

        jQuery(document).on('focus', '.c-dropdown .c-dropdown__field', function () {
            var dropdown = jQuery(this).closest('.c-dropdown');
            if (!dropdown.hasClass('open')) {
                dropdown.addClass('open');
            }
        });
    }());
    
    var CDropdownEvents = (function() {
        jQuery('.c-dropdown__list li').on('click', function(e) {
            var dropdown = jQuery(this).closest('.c-dropdown');
            var select = dropdown.find('.c-dropdown__select');
            var selectedValue = jQuery(this).data('value');
            dropdown.attr('data-selected', true);
            select.val(selectedValue); 
            select.trigger('change');
        });

        jQuery('.c-dropdown__select').on('change', function() {
            var selectedValue = jQuery(this).val();
            var action = jQuery(this).data('action');

            switch(action) {
                case 'filter_by_state':

                    filterByState(selectedValue);
                    break;
            }
        });

        function filterByState(selectedValue) {
            var text = document.querySelector('.results-section').getAttribute('data-term');
            var offset = 0;
            var totalCount = parseInt(jQuery('.sfilters a[data-filter="job"]').attr('data-total'));
    
            var data = {
                action: 'searchMoreJobs', 
                offset: offset,
                s: text,
                filters: [
                    {
                        type: 'state',
                        value: selectedValue
                    }
                ]
            };
    
            jQuery.ajax({
                url: ajaxURL,
                type: 'post',
                data: data,
                dataType: 'json',
                beforeSend: function () {
                    jQuery('#search-loadmore-jobs').attr('disabled', true);
                    jQuery('.row.row--results').addClass('loading');
                    searchFilterRunning = true;
                },
                error: function (res) {
                    jQuery('.col[data-type="job"]:not(.col--filter-info-job)').each(function() {
                        jQuery(this).remove(); 
                    });
                    jQuery('#search-loadmore-jobs').hide();
                    jQuery('.row.row--results').removeClass('loading');
                    searchFilterRunning = false;
                    console.error(res);
                },
                success: function (response) {
                    if (response.success) {
                        totalCount = response.totalCount;
                        offset = offset + parseInt(response.data.length);
    
                        jQuery('.sfilters a[data-filter="job"]').attr('data-total', totalCount);
                        jQuery('.sfilters a[data-filter="job"]').attr('data-count', '' + offset);
    
                        jQuery('.col[data-type="job"]:not(.col--filter-info-job)').each(function() {
                            jQuery(this).remove(); 
                        });
    
                        jQuery('.sresults').append(response.html);
    
                        if (offset >= totalCount) {
                            jQuery('#search-loadmore-jobs').hide();
                        } else {
                            jQuery('#search-loadmore-jobs').attr('disabled', false);
                        }
                    } else {
                        jQuery('#search-loadmore-jobs').hide();
                        jQuery('.col[data-type="job"]:not(.col--filter-info-job)').each(function() {
                            jQuery(this).remove(); 
                        });
                    }
                    jQuery('.row.row--results').removeClass('loading');
                    searchFilterRunning = false;
                }
            });
        }
    }());

    var NRCookies = (function() {

        function initCookies() {
            var NRU_site = Cookie.get('nru-site'),
                NRU_home = undefined,
                expireInDays = 365 * 100;
            
            /* GLobal site cookie */
            if( NRU_site == undefined ) {
                Cookie.set('nru-site', '1', expireInDays);
            }
            else {
                if( '1' == NRU_site ) {
                    Cookie.set('nru-site', '2', expireInDays);
                }
            }

            /* GLobal Home cookie */
            var isHome = jQuery('body').hasClass('home');
            if( isHome ) {
                NRU_home = Cookie.get('nru-home');

                if( NRU_home == undefined ) {
                    Cookie.set('nru-home', '1', expireInDays);
                }
                else {
                    if( '1' == NRU_home ) {
                        Cookie.set('nru-home', '2', expireInDays);
                    }
                }
            }
        }

        initCookies();

        var siteNewUser = function (strName) {
            var NRU_site = Cookie.get('nru-site');
            if( undefined == NRU_site || '1' == NRU_site ) {
                return true;
            }
            return false;
        };

        var homeNewUser = function (strName) {
            var NRU_home = Cookie.get('nru-home');
            if( undefined == NRU_home || '1' == NRU_home ) {
                return true;
            }
            return false;
        };

        return {
            isSiteNewUser: siteNewUser,
            isHomeNewUser: homeNewUser,
        };

    }());

    var BannerValueProps = (function() {
        var section = jQuery('.banner-value-props');
    
        if (section.length === 0) {
          return; 
        }
    
        function updateScrollAnimation() {
          if( section.hasClass('hidden') ) {
            return;
          }
          var list = jQuery('.banner-value-props ul:visible');
          var containerWidth = list.parent().outerWidth(); 
          var listWidth = list[0].scrollWidth; 
          var scrollDistance = listWidth - containerWidth;
    
          if (scrollDistance > 0) {
            scrollDistance += 30; 
          }
          
          var baseSpeed = 50; 
          var duration = scrollDistance / baseSpeed;
    
          jQuery('.banner-value-props').css({
            '--v-props-scroll-dist': `-${scrollDistance}px`, 
            '--v-props-anim-duration': `${duration}s`
          });
        };
    
        jQuery(window).on("resize", updateScrollAnimation);
    
        setTimeout(updateScrollAnimation, 1500);
    
    })();
    
    var HorizontalScrollDrag = (function () {
        var container = jQuery('.h-scrollbar');
    
        if (container.length === 0) return;
    
        container.each(function () {
            var $this = jQuery(this);
    
            function updateCursor() {
                setTimeout(function () {
                    if ($this[0].scrollWidth > $this[0].clientWidth) {
                        $this.css('cursor', 'grab');
                    } else {
                        $this.css('cursor', 'default');
                    }
                }, 100);
            }
    
            updateCursor();
    
            var isDown = false;
            var startX;
            var scrollLeft;
    
            $this.on('mousedown', function (e) {
                if ($this[0].scrollWidth <= $this[0].clientWidth) return;
    
                isDown = true;
                $this.addClass('is-dragging');
                startX = e.pageX - $this.offset().left;
                scrollLeft = $this.scrollLeft();
                $this.css('cursor', 'grabbing');
            });
    
            $this.on('mouseleave mouseup', function () {
                isDown = false;
                $this.removeClass('is-dragging');
                updateCursor();
            });
    
            $this.on('mousemove', function (e) {
                if (!isDown) return;
                e.preventDefault();
                var x = e.pageX - $this.offset().left;
                var walk = (x - startX) * 2;
                $this.scrollLeft(scrollLeft - walk);
            });
    
            $this.on('dragstart', function (e) {
                e.preventDefault();
            });
    
            jQuery(window).on('resize', updateCursor);
        });
    })();

    var HeaderSubmitToHeroForm = (function () {
        var headerSubmit = jQuery('.header_submit_hero_form a');

        if (headerSubmit.length === 0) return;

        headerSubmit.on('click', function(e) {
            e.preventDefault();

            SmoothScroll.to('.hero .form-header');
        });

    })();

    var SearchResultsSlider = (function() {

        var sliders = jQuery('div[data-id="search_results_slider"]'); 
    
        if (sliders.length == 0) { return; }
    
        function initFlickity(slider) {

            if (jQuery(window).width() < 960) {

                var slideCount = slider.find('.search-card').length; 

                if (!slider.hasClass('flickity-enabled') && slideCount > 0) {
                    slider.flickity({
                        cellAlign: slideCount < 3 ? 'left' : 'center',
                        contain: slideCount < 3 ? true : false,
                        prevNextButtons: slideCount > 2,
                        wrapAround: slideCount < 3 ? false : true,
                        pageDots: false,
                        groupCells: true
                    });
                }
            } else {
                if (slider.hasClass('flickity-enabled')) {
                    slider.flickity('destroy');
                }
            }
        }

        function destroyFlickity(slider) {
            if (slider.hasClass('flickity-enabled')) {
                slider.flickity('destroy');
            }
        }

        jQuery(window).on('resize', function() {
            sliders.each(function() {
                var slider = jQuery(this); 
                initFlickity(slider);
            });
        });

        jQuery(document).on('initializeSlider', function(event, selector) {
            var targetSlider = jQuery(selector);
    
            if (targetSlider.length > 0) {
                initFlickity(targetSlider);  
            }
        });

        jQuery(document).on('destroySlider', function(event, selector) {
            var targetSlider = jQuery(selector);
    
            if (targetSlider.length > 0) {
                destroyFlickity(targetSlider);
            }
        });
    
    }());

    var SearchResultsPopup = (function() {

        var searchInput = document.querySelector('.gheader__search input'),
            searchPopup = document.querySelector('.search-dropdown');

        if (!searchInput || !searchPopup) {
            return;
        }

        var searchPopupContent = document.querySelector('.search-dropdown .searchbar-cnt'),
            homeHeader = document.querySelector('.gheader.gheader--home'),
            searchTimer,
            lastSearchTerm = '',
            jobContainer = document.querySelector('.searchbar-cnt__res-group div[data-type="job"]'),
            destinationsContainer = document.querySelector('.searchbar-cnt__res-group div[data-type="destinations"]'),
            postContainer = document.querySelector('.searchbar-cnt__res-group div[data-type="post"]'),
            mobileBurguerBtn = document.querySelector('.gheader-top .header-burger-search'),
            searchMoreBtn = document.getElementById('search_more_results'),
            searchCloseBtn = document.getElementById('searchbar_close');

        function resetSearch() {
            lastSearchTerm = '';
            searchPopup.classList.remove('show-search-results');
            if (homeHeader) {
                homeHeader.classList.remove('gheader--search-popup');
            }

            jQuery(document).trigger('destroySlider', jobContainer);
            jQuery(document).trigger('destroySlider', destinationsContainer);
            jQuery(document).trigger('destroySlider', postContainer);

            jobContainer.innerHTML = '';
            destinationsContainer.innerHTML = '';
            postContainer.innerHTML = '';
        }
        
        function close() {
            if (searchPopup.classList.contains('show-search-results')) {
                searchPopup.classList.remove('show-search-results'); 
            }
            if (homeHeader) {
                Header.BurgerSearch.close();
            }
        }

        function open() {
            if (homeHeader) {
                homeHeader.classList.add('gheader--search-popup');
                Header.BurgerSearch.open(); 
                if (window.innerWidth >= 960) {
                    document.body.classList.remove('no-scroll');
                }
            }
            searchPopup.classList.add('show-search-results');
        }
    
        searchInput.addEventListener('input', function() {
            clearTimeout(searchTimer);
            let searchTerm = this.value.trim();
    
            if (searchTerm.length < 2) {
                resetSearch();

                return;
            } else {
                open();
            }

            var query = encodeURIComponent(searchTerm);
            if( query ) {
                searchMoreBtn.href = `/?s=${query}`;
            }
    
            if (searchTerm === lastSearchTerm) {
                return;
            }
    
            searchTimer = setTimeout(function() {
                lastSearchTerm = searchTerm;

                if(searchPopupContent) {
                    searchPopupContent.classList.add('ajax-loader');
                }
    
                var jobsRequest = jQuery.ajax({
                    url: ajaxURL,
                    type: 'get',
                    data: { action: 'search_jobs', term: searchTerm, limit: 2 },
                    dataType: 'json',
                    success: function( data, status, xhr ) {
                        var jobsUrl = jQuery('#searchbar_more_jobs').attr('data-href');
                        if( true == data.success && data.state ) {
                            jobsUrl = jobsUrl + '/destination/' + data.state + '/jobType/All Types/';
                        }
                        jQuery('#searchbar_more_jobs').attr('href', jobsUrl);
                    }
                });
    
                var postsRequest = jQuery.ajax({
                    url: ajaxURL,
                    type: 'get',
                    data: { action: 'search_posts', term: searchTerm, limit: 3 },
                    dataType: 'json'
                });

                function handleContainer(container, response, type) {
                    if (response.success && container) {
                        jQuery(document).trigger('destroySlider', container);
                        container.innerHTML = response[`${type}_html`] || '';
                        jQuery(document).trigger('initializeSlider', container);
                    } else if (container) {
                        jQuery(document).trigger('destroySlider', container);
                        container.innerHTML = '';
                    }
                }
    
                jQuery.when(jobsRequest, postsRequest).done(function(jobRes, postRes) {

                    jobRes = jobRes[0];
                    postRes = postRes[0];
    
                    handleContainer(jobContainer, jobRes, 'jobs');
                    handleContainer(destinationsContainer, postRes, 'destinations');
                    handleContainer(postContainer, postRes, 'posts');
    
                    if(searchPopupContent) {
                        searchPopupContent.classList.remove('ajax-loader');
                    }

                }).fail(function() {
                    if(searchPopupContent) {
                        searchPopupContent.classList.remove('ajax-loader');
                    }
                });
    
            }, 480);
        });

        if(mobileBurguerBtn) {
            mobileBurguerBtn.addEventListener('click', function() {
                searchInput.value = '';
                resetSearch();
            });
        }

        function initializeMobileFilters() {
            const filterItems = document.querySelectorAll(".filters-tags__item");
            const resultGroups = document.querySelectorAll(".searchbar-cnt__res-group");
            let isMobile = window.innerWidth < 960;
        
            function updateFilters() {
                const activeFilter = document.querySelector(".filters-tags__item.is-active");
                const selectedValue = activeFilter ? activeFilter.getAttribute("data-value") : null;
        
                resultGroups.forEach(group => {
                    const slider = group.querySelector('div[data-id="search_results_slider"]');
                    const groupType = slider?.getAttribute("data-type");
        
                    if (slider) {
                        jQuery(document).trigger("destroySlider", slider);
                    }
        
                    if (groupType === selectedValue) {
                        group.classList.remove("hidden");
                        if (slider) {
                            setTimeout(() => {
                                jQuery(document).trigger("initializeSlider", slider);
                            }, 100);
                        }
                    } else {
                        group.classList.add("hidden");
                    }
                });
            }
        
            function handleFilterSelection(event) {
                filterItems.forEach(item => item.classList.remove("is-active"));
                event.target.classList.add("is-active");
                updateFilters();
            }
        
            function handleResize() {
                const nowMobile = window.innerWidth < 960;
        
                if (nowMobile && !isMobile) {
                    filterItems.forEach(item => item.classList.remove("is-active"));
                    filterItems[0].classList.add("is-active");
                    updateFilters();
                } else if (!nowMobile && isMobile) {
                    resultGroups.forEach(group => {
                        group.classList.remove("hidden");
                    });
                }
        
                isMobile = nowMobile;
            }
        
            filterItems.forEach(item => item.addEventListener("click", handleFilterSelection));
            window.addEventListener("resize", handleResize);
        
            if (isMobile) {
                filterItems[0].click();
            }
        }

        initializeMobileFilters();

        document.addEventListener('click', function(event) {    
            var isInsideDropdown = event.target.closest('.search-dropdown .search-dropdown__wrap');
            var isOnInput = event.target === searchInput;  

            if (window.innerWidth >= 960) {
                if (!isInsideDropdown && !isOnInput) {
                    close();
                }
            }else {
                var homeOverlay = document.querySelector('.gheader__search.active');

                if (homeOverlay && homeOverlay.contains(event.target) && !isOnInput && !searchPopup.classList.contains('show-search-results')) {
                    jQuery('.header-burger-search').trigger('click');
                }else if (searchPopup.classList.contains('show-search-results') && searchPopup.contains(event.target) && !isInsideDropdown) {
                    if (homeOverlay) {
                        jQuery('.header-burger-search').trigger('click');
                    }else {
                        jQuery('#searchbar_close').trigger('click');
                    }
                }
            }
        });

        if(searchCloseBtn) {
            searchCloseBtn.addEventListener('click', function() {
                close();
            });
        }

    }());

    var SignUpStepsForm = (function() {

        var progressbar = jQuery('.s-progressbar'),
            formWrapper = jQuery('#gform_wrapper_3'),
            form = jQuery('#gform_3');

        if ( !form.length ||  !progressbar.length ) return; 

        jQuery(document).on('gform_post_render', function(event, formId, currentPage) {
            if (formId !== 3) return;

            var legend = formWrapper.find('.gform_required_legend');
            legend.hide();
        
            var clone = legend.clone();
            jQuery('#gform_3').append(clone);
            clone.addClass('c-required-legend').show();
        
            if(currentPage > 1) {
                clone.hide();
            } 
        });

        jQuery(document).on('gform_page_loaded', function(event, formId, currentPage) {
            if (formId !== 3) return;

            if (currentPage == 2) { 
                var text2 = progressbar.find('.s-progressbar__label').data('text2');
                jQuery('.s-progressbar .s-progressbar__prg>div').css('width', '77%');
                jQuery('.s-progressbar__label').text(text2);
            }else {
                var text1 = progressbar.find('.s-progressbar__label').data('text1');
                jQuery('.s-progressbar .s-progressbar__prg>div.desk-only').css('width', '44%');
                jQuery('.s-progressbar .s-progressbar__prg>div.mob-only').css('width', '27%');
                jQuery('.s-progressbar__label').text(text1);
            }
        });
    }());

    var SignupTopNav = (function() {

        if (document.body.getAttribute('data-page-slug') !== 'sign-up') return;

        if(isPautaReferer()) {
            document.body.classList.add('has-pauta-referer');
        }

        function isPautaReferer() {
            var referer = document.referrer;
            if (!referer) return false;
            var refererLower = referer.toLowerCase();
            var excludedSources = [
                '/refer-a-traveler/affiliate/mursetobe/',
                '/refer-a-traveler/affiliate/vw3-0/',
                '/refer-a-traveler/affiliate/melsvanlife/',
                '/refer-a-traveler/affiliate/roamingwiththereynolds/',
                '/travel-comfortably-with-host-healthcare-5/?id=passportsandpreemies',
                '/nursekayknows/',
                '/travel-comfortably-with-host-healthcare-2/?id=jakegrez',
                '/refer-a-traveler/affiliate/katann/',
                '/refer-a-traveler/affiliate/bribrithenurse/',
                '/eu_needme/',
                '/refer-a-traveler/affiliate/nursenoriii/',
                '/refer-a-traveler/affiliate/julesspawn/',
                '/refer-a-traveler/affiliate/laylathenurse/',
                '/refer-a-traveler/affiliate/younessrn',
                '/refer-a-traveler/affiliate/xuebru',
                '/refer-a-traveler/affiliate/create-your-own-roadshow/',
                '/refer-a-traveler/affiliate/yonasthept',
                '/refer-a-traveler/affiliate/tracie-love',
                '/travel-comfortably-with-host-healthcare-4/?id=hale.on.a.trail',
                '/travel-comfortably-with-host-healthcare-3/?id=wereoutnabout',
            ];
            for (var i = 0; i < excludedSources.length; i++) {
                var path = excludedSources[i].toLowerCase();
                if (refererLower.indexOf(path) !== -1)  return true;
            }
        
            return false;
        }
    }());

    var SignupReviewsSlider = (function() {
        var slider = jQuery('div[data-id="reviews_slider"]');
        if (slider.length == 0) { return; }
    
        slider.flickity({
            cellAlign: 'left',
            contain: true,
            prevNextButtons: true,
            wrapAround: true,
            pageDots: false,
        });
    }());

});